import React from 'react'
import clsx from 'clsx'
import InputText from '../InputText'

import './step1.scss'
import Icon from '../Icon/Icon'

export const Step1 = ({
  otherClasses,
  choices,
  addChoiceHandler,
  removeChoiceHandler,
  handleChange,
  onChoiceChange,
  errorMessage,
  state,
}) => {
  const step1Classes = clsx(
    otherClasses,
    'px-6 pt-6 pb-5 lg:pt-[40px] lg:px-[40px] flex flex-col gap-6 lg:gap-[40px] '
  )

  return (
    <div className={step1Classes} data-testid="step1">
      <div className="lg:pb-[40px] pb-6 border-b-[1px] border-b-gray-100 ">
        <div className="w-full lg:w-[397px] flex flex-col gap-6">
          <InputText
            label="Condo Project Name"
            // placeholder="Project Name"
            required={true}
            type="text"
            warning={errorMessage?.project}
            value={state?.project || ''}
            onChange={handleChange}
            name="project"
          />
        </div>
      </div>
      {/* <div className="lg:pb-[40px] pb-6 border-b-[1px] border-b-gray-100 ">
        <div className="flex flex-col gap-6 lg:gap-[40px]  ">
          {choices?.length > 0 &&
            choices.map((choice, index) => {
              return (
                <div key={index} className="flex flex-col gap-6">
                  <div className="flex justify-between">
                    <label
                      htmlFor="choice"
                      className="font-work-sans text-[16px] lg:text-[20px] font-semibold text-primary_heading_color  leading-[27px]"
                    >
                      Choice #{index + 1}
                    </label>
                    {index > 0 && (
                      <button
                        onClick={() => removeChoiceHandler(index)}
                        className="border-[1px] rounded-lg border-primary_heading_color"
                      >
                        <Icon icon="minus" iconHeight={24} iconWidth={24} />
                      </button>
                    )}
                  </div>

                  <div className="grid grid-cols-1 lg:grid-cols-3 w-full  gap-y-2 lg:gap-y-0 lg:gap-x-6">
                    <div className="w-full flex flex-col gap-2">
                      <InputText
                        id={index}
                        label="Model Name"
                        required={false}
                        name={'modal'}
                        warning={index === errorMessage?.modal}
                        onChange={onChoiceChange}
                        value={choice?.modal || ''}
                        placeholder={'Model'}
                        type="text"
                      />
                    </div>
                    <div className="w-full flex flex-col gap-2">
                      <InputText
                        id={index}
                        label="Type"
                        warning={index === errorMessage.type}
                        required={false}
                        name={'type'}
                        onChange={onChoiceChange}
                        value={choice.type || ''}
                        placeholder={'Type'}
                        type="text"
                      />
                    </div>
                    <div className="w-full flex flex-col gap-2">
                      <InputText
                        label="Notes"
                        warning={index === errorMessage.notes}
                        required={false}
                        id={index}
                        name="notes"
                        onChange={onChoiceChange}
                        value={choice?.notes || ''}
                        placeholder={'Notes'}
                        type="text"
                      />
                    </div>
                  </div>
                </div>
              )
            })}
        </div>
        <button
          type="button"
          className=" mt-6 lg:mt-[40px] lg:tracking-[0.42px] uppercase font-work-sans text-[12px] tracking-[0.36px] lg:text-[14px] font-semibold leading-[18px] "
          onClick={() => addChoiceHandler()}
        >
          + Add another choice
        </button>
      </div> */}
      {/* <div className="flex flex-col gap-6 lg:gap-[40px]  ">
        <div className="flex flex-col lg:flex-row gap-4 lg:gap-[64px]">
          <div className="flex flex-col gap-4">
            <label
              htmlFor="parking"
              className={clsx(
                errorMessage?.parking
                  ? 'font-work-sans text-[16px] lg:text-[20px] font-semibold text-[#ff4444]  leading-[27px]'
                  : 'font-work-sans text-[16px] lg:text-[20px] font-semibold text-primary_heading_color  leading-[27px]'
              )}
            >
              Parking <span className="text-red-500">*</span>
            </label>
            <div className="flex gap-6">
              <label
                className=" container flex gap-2 font-work-sans text-[12px] lg:text-[14px] font-normal text-primary_heading_color leading-[20px]"
                htmlFor="parking-yes"
              >
                <input
                  onChange={(e) => handleChange(e)}
                  type="radio"
                  required={true}
                  id="parking-yes"
                  name="parking"
                  value="yes"
                  checked={state?.parking === 'yes'}
                  className="radio_button"
                />
                <span className={clsx('checkmark')}></span>
                Yes
              </label>

              <label
                className="container flex gap-2 font-work-sans text-[12px] lg:text-[14px] font-normal text-primary_heading_color leading-[20px]"
                htmlFor="parking-no"
              >
                <input
                  type="radio"
                  onChange={(e) => handleChange(e)}
                  id="parking-no"
                  required={true}
                  checked={state?.parking === 'no'}
                  name="parking"
                  value="no"
                  className="radio_button"
                />
                <span className={clsx('checkmark')}></span>
                No
              </label>
            </div>
          </div>
          <div className="flex flex-col gap-4">
            <label
              htmlFor="locker"
              className={clsx(
                errorMessage?.locker
                  ? 'font-work-sans text-[16px] lg:text-[20px] font-semibold text-[#ff4444]  leading-[27px]'
                  : 'font-work-sans text-[16px] lg:text-[20px] font-semibold text-primary_heading_color  leading-[27px]'
              )}
            >
              Locker <span className="text-red-500">*</span>
            </label>
            <div className="flex gap-6">
              <label
                className="container flex gap-2 font-work-sans text-[12px] lg:text-[14px] font-normal text-primary_heading_color leading-[20px]"
                htmlFor="locker-yes"
              >
                <input
                  type="radio"
                  onChange={(e) => handleChange(e)}
                  id="locker-yes"
                  name="locker"
                  required={true}
                  checked={state?.locker === 'yes'}
                  value="yes"
                  className="radio_button"
                />
                <span className={clsx('checkmark')}></span>
                Yes
              </label>
              <label
                className=" container flex gap-2 font-work-sans text-[12px] lg:text-[14px] font-normal text-primary_heading_color leading-[20px]"
                htmlFor="locker-no"
              >
                <input
                  type="radio"
                  id="locker-no"
                  name="locker"
                  required={true}
                  onChange={(e) => handleChange(e)}
                  checked={state?.locker === 'no'}
                  value="no"
                  className="radio_button"
                />
                <span className={clsx('checkmark')}></span>
                No
              </label>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  )
}

export default Step1
